/* One finite CSS flow, paused outside the viewport. No render loop. */
(() => {
  const map = document.querySelector('[data-flow]');
  if (!map || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) map.classList.add('flow-started');
    map.classList.toggle('flow-visible', entry.isIntersecting);
  }, {threshold: 0.25});
  observer.observe(map);
})();
